import { render, staticRenderFns } from "./mainDealerPieChart.vue?vue&type=template&id=5ef2fdbd&scoped=true"
import script from "./mainDealerPieChart.vue?vue&type=script&lang=js"
export * from "./mainDealerPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef2fdbd",
  null
  
)

export default component.exports